import styles from './MainBanner.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useEffect, useState } from 'react';
import banner from '../../assets/banner/mainBanner.png';
import banner2 from '../../assets/banner/mainBanner02.jpg';
import banner3 from '../../assets/banner/mainBanner03.png';
import banner4 from '../../assets/banner/mainBanner04.jpg';
import banner5 from '../../assets/banner/mainBanner05.jpg';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';

const defaultBannerList: IBannerType[] = [
  { image: banner5, url: 'event/22' },
  { image: banner4, url: 'event/21' },
  { image: banner3, url: 'event/20' },
  { image: banner },
];
export interface IBannerType {
  image: string;
  url?: string;
}
function MainBanner() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  const navigate = useNavigate();

  // Fetch banner data from API
  const { data: apiBannerData = [] } = useQuery<IBannerType[]>(
      'banner-advertisement',
      async () => {
        return await axiosClient
            .get('/data/banner/advertisement')
            .then((res) =>
                res.data.map((banner: any) => ({
                  image: banner.image,
                  url: banner.link
                }))
            );
      },
      {
        staleTime: 60000 * 60, // 1 hour cache
      }
  );
  const slideList = apiBannerData.length > 0 ? apiBannerData : defaultBannerList;

  return (
    <div className={styles.container}>
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {slideList.map((slide, idx) => (
            <SwiperSlide
              key={idx}
              onClick={() => {
                if (slide.url) navigate(slide.url);
              }}
            >
              <img
                src={slide.image}
                alt="banner"
                style={{ cursor: slide.url ? 'pointer' : 'unset' }}
              />
            </SwiperSlide>
          ))}
          {/* <SwiperSlide>
            <img src={banner3} alt="banner" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={banner2} alt="banner" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={banner} alt="banner" />
          </SwiperSlide> */}
        </Swiper>
        <ul className={styles.paginationWrap}>
          {slideList.map((banner, idx) => (
            <li
              key={idx}
              onClick={() => swiper?.slideTo(idx, 200)}
              className={idx == activeIdx ? styles.hit : ''}
            ></li>
          ))}
        </ul>
      </div>
    </div>
  );
}
export default MainBanner;
